import Vue from 'vue'
import Router from 'vue-router'
import headerList from "@/Common/headerList";
import bottomInfo from "@/Common/bottomInfo"
import homePage from "@/pages/homePage";
import homeShow from "@/pages/Home/homeShow";
import aboutUs from "@/pages/Intro/aboutUs";
import productShow from "@/pages/Product/productShow";
import technologyInfo from "@/pages/Technology/technologyInfo";
import contactUs from "@/pages/Contact/contactUs"


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Home',
    },
    {
      path: '/',
      component: homePage,
      children: [
        {
        path: '/Home',
        name: '首页',
        components: {
          default: homeShow,
          top: headerList,
        }
      },
        {
          path: '/AboutUs',
          name: '公司简介',
          components: {
            default: aboutUs,
            top: headerList,
          },
        },
        {
          path: '/ProductsShow',
          name: '产品展示',
          components: {
            default: productShow,
            top: headerList,
            bottom:bottomInfo
          },
        },
        {
          path: '/TechnologyInfo',
          name: '技术实力',
          components: {
            default: technologyInfo,
            top: headerList,
            bottom: bottomInfo
          },
        },
        {
          path: '/contactUs',
          name: '联系我们',
          components:
            {
              default: contactUs,
              top: headerList,
              bottom: bottomInfo
            }
        }
      ]
    }]
})






// WEBPACK FOOTER //
// ./src/router/index.js